var _path, _path2, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93965 0H8.68568L13.1428 4.33083L13.1428 13.1846C13.1428 14.2754 12.2753 15.1579 11.2069 15.1579H3.93965C2.86745 15.1579 2 14.2754 2 13.1846V1.97332C1.99998 0.882503 2.86743 0 3.93965 0Z",
    fill: "url(#paint0_linear_14_4223)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68579 0V4.36364H13.1429L8.68579 0Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.66675,
    y: 0.666748,
    width: 11.3333,
    height: 15.3333,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_4223",
    x1: 7.5714,
    y1: 0,
    x2: 7.5714,
    y2: 15.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AD74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFF4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.d9c7f37848222952128163f42149fa18.svg";
export { ForwardRef as ReactComponent };